import { PromptStepSchema } from '@feedyou/schema'

import { ValidatorType } from './const'

export function isValidatorActive(
  validator?: PromptStepSchema['validator']
): validator is { type: ValidatorType } {
  return !!validator?.type && validator?.type !== 'none'
}
